import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';
import { createRicosFunctionalExtension } from 'wix-tiptap-extensions';

import { SELECTION_CLASS } from './constants';

export const selection = createRicosFunctionalExtension({
  type: 'extension',
  groups: [],
  name: 'selection',

  createExtensionConfig() {
    return {
      name: this.name,

      addProseMirrorPlugins() {
        return [
          new Plugin({
            key: new PluginKey('selection'),
            props: {
              decorations(state) {
                if (state.selection.empty) {
                  return null;
                }

                return DecorationSet.create(state.doc, [
                  Decoration.inline(state.selection.from, state.selection.to, {
                    class: SELECTION_CLASS,
                  }),
                ]);
              },
            },
          }),
        ];
      },
    };
  },
});
